// src/components/delivery/DeliveryStats.jsx
import React from "react";
import { Package, TrendingUp, Truck, CheckCircle, Clock, AlertCircle } from "react-feather";

const DeliveryStats = ({ stats, loading, onStatClick }) => {
  const statCards = [
    {
      title: "Total Orders",
      value: stats.totalOrders || 0,
      icon: Package,
      color: "bg-blue-500",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      filter: "ALL",
      description: "All assigned orders"
    },
    {
      title: "Processing",
      value: stats.processingOrders || 0,
      icon: Clock,
      color: "bg-yellow-500",
      bgColor: "bg-yellow-50",
      textColor: "text-yellow-600",
      filter: "PROCESSING",
      description: "Being prepared"
    },
    {
      title: "Shipped",
      value: stats.shippedOrders || 0,
      icon: TrendingUp,
      color: "bg-purple-500",
      bgColor: "bg-purple-50",
      textColor: "text-purple-600",
      filter: "SHIPPED",
      description: "Ready for pickup"
    },
    {
      title: "On the Way",
      value: stats.onTheWayOrders || 0,
      icon: Truck,
      color: "bg-orange-500",
      bgColor: "bg-orange-50",
      textColor: "text-orange-600",
      filter: "ON_THE_WAY",
      description: "In transit"
    },
    {
      title: "Delivered",
      value: stats.deliveredOrders || 0,
      icon: CheckCircle,
      color: "bg-green-500",
      bgColor: "bg-green-50",
      textColor: "text-green-600",
      filter: "BOOK_WITH_ME",
      description: "Successfully delivered"
    },
    {
      title: "Pending",
      value: stats.pendingDeliveries || 0,
      icon: AlertCircle,
      color: "bg-red-500",
      bgColor: "bg-red-50",
      textColor: "text-red-600",
      filter: "PENDING",
      description: "Awaiting delivery"
    },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-sm p-4 sm:p-6 animate-pulse border border-gray-100"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-200 rounded-lg"></div>
            </div>
            <div className="h-8 bg-gray-200 rounded mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div
            key={index}
            onClick={() => stat.filter && onStatClick && onStatClick(stat.filter)}
            className={`bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-4 sm:p-5 border border-gray-100 group ${
              stat.filter ? "cursor-pointer hover:border-primary/40 hover:scale-105" : ""
            }`}
            title={stat.description}
          >
            <div className="flex items-center justify-between mb-3">
              <div className={`${stat.bgColor} p-2.5 sm:p-3 rounded-xl shadow-sm group-hover:shadow transition-all`}>
                <Icon className={stat.textColor} size={20} />
              </div>
            </div>
            <div className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 group-hover:text-primary transition-colors">
              {stat.value}
            </div>
            <div className="text-xs sm:text-sm text-gray-600 font-medium mb-0.5">{stat.title}</div>
            <div className="text-xs text-gray-400 hidden sm:block">{stat.description}</div>
          </div>
        );
      })}
    </div>
  );
};

export default DeliveryStats;
